import { render, staticRenderFns } from "./BrankasSuccessPageComponent.vue?vue&type=template&id=00bbfcc6&scoped=true&"
import script from "./BrankasSuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./BrankasSuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./BrankasSuccessPageComponent.vue?vue&type=style&index=0&id=00bbfcc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bbfcc6",
  null
  
)

export default component.exports